export interface ISupplierEmailValidationResponse {
    valid: boolean;
    errorMessages?: SupplierEmailValidationMessage[];
}

export enum SupplierEmailValidationMessage {
    SUPPLIER_EMAIL_NOT_VALID = 'SUPPLIER_EMAIL_NOT_VALID',
}
